import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

import { authenticatedRoute } from '@/app/routes/authenticated'
import { pageSearch as page, textSearch as text } from '@/shared/api/search'
import { requirePermission } from '@/shared/auth/guards'

const companiesSearchSchema = z.object({
  page,
  search: text,
  status: z.enum(['active', 'prospect', 'archived']).optional().catch(undefined),
  kind: z.enum(['company', 'person']).optional().catch(undefined),
})

export const companiesRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/companies',
  beforeLoad: requirePermission('companies.view'),
})

export const companiesIndexRoute = createRoute({
  getParentRoute: () => companiesRoute,
  path: '/',
  validateSearch: (search) => companiesSearchSchema.parse(search),
  component: lazyRouteComponent(() => import('./pages/companies-page'), 'CompaniesPage'),
})

// "new" é tratado como id especial na própria página de cadastro/edição.
export const companyFormRoute = createRoute({
  getParentRoute: () => companiesRoute,
  path: '$companyId',
  component: lazyRouteComponent(() => import('./pages/company-form-page'), 'CompanyFormPage'),
})

export const companiesRoutes = companiesRoute.addChildren([companiesIndexRoute, companyFormRoute])
